import * as React from 'react';
import { useState, useEffect } from 'react';

var capitalizaName = function capitalizaName(name) {
  return name[0].toUpperCase() + name.slice(1);
};

export var AssignedEmail = function AssignedEmail(_ref) {
  var verbose = _ref.verbose;

  var _useState = useState(null),
      employee = _useState[0],
      setEmployee = _useState[1];

  useEffect(function () {
    setEmployee(new URLSearchParams(window !== undefined && window.location.search).get('assigned'));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, employee && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: "mailto:" + employee + "_s@wish-to-go.com",
    target: "_blanc"
  }, capitalizaName(employee)), verbose && ', your assigned support team member'), !employee && /*#__PURE__*/React.createElement("a", {
    href: "mailto:support@wish-to-go.com",
    target: "_blanc"
  }, "the support team"));
};
export var AssignedName = function AssignedName() {
  var _useState2 = useState(null),
      employee = _useState2[0],
      setEmployee = _useState2[1];

  useEffect(function () {
    setEmployee(new URLSearchParams(window !== undefined && window.location.search).get('assigned'));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, employee ? /*#__PURE__*/React.createElement("span", null, capitalizaName(employee)) : /*#__PURE__*/React.createElement("span", null, "support team"));
};